<div id="cover" *ngIf="isLoading"></div>
<div class="tracker" *ngIf="!isLoading">

  <div class="header-container">
    <div class="kpi-strip">
      <div class="info-card kpi-card" [style.border-top-color]="'#2fa84f'">
        <div class="card-header">
          <div class="icon-badge" [style.background]="'#2fa84f'">
            <i class="fa-solid fa-sack-dollar"></i>
          </div>
          <div class="card-title">
            <div>
              Total Spend
            </div>
            <div class="kpi-hint" [title]="'(All Projects)'">
              (All Projects)
            </div>
          </div>
        </div>
        <div class="card-desc kpi-val">{{ fmt(grandTotal) }}</div>
        <i class="fa-solid fa-sack-dollar bg-icon"></i>
      </div>

      <div class="info-card kpi-card" [style.border-top-color]="'#3b8bd4'">
        <div class="card-header">
          <div class="icon-badge" [style.background]="'#3b8bd4'">
            <i class="fa-solid fa-chess-king"></i>
          </div>
          <div class="card-title">
            Largest Project
            <span class="kpi-hint" *ngIf="largest?.project_name && largest?.project_name !== ''"
              [title]="largest?.project_name | uppercase">
              ({{ largest?.project_name | uppercase }})
            </span>
          </div>
        </div>
        <div class="card-desc kpi-val">{{ largest ? fmt(largest.amount) : '—' }}</div>
        <i class="fa-solid fa-chess-king bg-icon"></i>
      </div>

      <div class="info-card kpi-card" [style.border-top-color]="'#e0a63b'">
        <div class="card-header">
          <div class="icon-badge" [style.background]="'#e0a63b'">
            <i class="fa-brands fa-buffer"></i>
          </div>
          <div class="card-title">No of Project</div>
        </div>
        <div class="card-desc kpi-val">{{ totalActiveProject }}</div>
        <i class="fa-brands fa-buffer bg-icon"></i>
      </div>
    </div>

    <div class="controls-wrapper">
      <div class="controls-group">
        <div class="control-item">
          <label class="label">From Year</label>
          <p-datepicker view="year" dateFormat="yy" [(ngModel)]="startYear" appendTo="body"
            (onSelect)="getToDate($event)"></p-datepicker>
        </div>
        <div class="control-item">
          <label class="label">To Year</label>
          <p-datepicker view="year" dateFormat="yy" [disabled]="!startYear" [(ngModel)]="endYear" appendTo="body"
            [minDate]="minToYear" (onSelect)="searchDataOnYear()"></p-datepicker>
        </div>
      </div>
      <div class="button-group">
        <button class="btn-secondary mt-4" *ngIf="startYear && endYear" (click)="clearFilter()">
          <i class="fa-solid fa-x"></i>
          Clear
        </button>
        <button class="btn-secondary mt-4" (click)="toggleSort()">
          <i class="fa-solid fa-arrow-down-wide-short" *ngIf="sortDesc"></i>
          <i class="fa-solid fa-arrow-down-short-wide" *ngIf="!sortDesc"></i>
          {{ sortDesc ? 'High' : 'Low' }}
        </button>
      </div>
    </div>
  </div>

  <div class="body-scroll-container" *ngIf="filteredProjects.length > 0">
    <div class="body">
      <!-- ─── LEFT: List panel ───────────────── -->
      <div class="list-panel">

        <div class="project-group" *ngFor="let p of filteredProjects; let i = index"
          [style.animation-delay]="(i * 0.04) + 's'">
          <div class="pcard-header" [style.background]=" selectedProjectId == p.project_id ? '#b5daff3b' : '#f1f1f1'"
            (click)="onClickProject(p.project_id,p)">
            <div class="accent-bar" [style.background]="'#3b8bd4'"></div>

            <div class="picon" style="background: white;"
              [style.border]="selectedProjectId == p.project_id ? '2px solid #7bb1e2' : '2px solid #00000052'">
              <span class="project-initial">{{ p.project_name.charAt(0).toUpperCase() }}</span>
            </div>

            <div class="pinfo">
              <div class="pname">{{ p.project_name | uppercase }}</div>
            </div>

            <div class="pamount">
              <div class="pamt">{{ fmt(p.amount) }}</div>
              <div class="ppct">{{ pct(p.amount, grandTotal) }}%</div>
            </div>

            <i class="ti chev-icon" [class.ti-chevron-down]="!isOpen(p.project_id)"
              [class.ti-chevron-up]="isOpen(p.project_id)" aria-hidden="true"></i>
          </div>

          <div class="sub-list" *ngIf="isProjectActive(p.project_id)">
            <div class="sub-row" *ngFor="let s of p.subProjects; let si = index"
              [style.background]="isSubSelected(s.form_id) ? '#b5daffc7' : ''"
              (click)="onClickSub(p.project_id, s.form_id,$event)">
              <div class="sub-rank" [style.background]="isSubSelected(s.form_id) ? 'white' : '#c1c1c180'"
                [style.color]="p.colorDark">
                {{ si + 1 }}
              </div>

              <span class="sub-name">{{ s.form_name }}</span>

              <span class="sub-amt">{{ fmt(s.amount) }}</span>

              <i class="ti ti-chevron-right sub-chev" [style.color]="isSubSelected(s.form_id) ? p.color : ''"
                aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div class="empty-list" *ngIf="filteredProjects.length === 0">
          <i class="ti ti-search-off" aria-hidden="true"></i>
          <p>No projects found</p>
        </div>
      </div>
      <!-- ─── RIGHT: Detail panel ───────────────── -->
      <div class="detail-panel">
        <div class="empty-detail" *ngIf="!detailEntity">
          <i class="fa-solid fa-hand-pointer"></i>
          <p>Click a Sub Project To View Details</p>
        </div>
        <div class="detail-inner" *ngIf="detailEntity" [attr.key]="detailEntity.id">

          <div class="detail-hero">
            <div class="stat-grid">
              <div class="info-card" [style.border-top-color]="'#2fa84f'">
                <div class="card-header">
                  <div class="icon-badge" [style.background]="'#2fa84f'">
                    <i class="fa-solid fa-circle-info"></i>
                  </div>
                  <div class="card-title">Current Report</div>
                </div>
                <div class="card-desc" [title]="detailEntity.form_name | uppercase">
                  {{ detailEntity.form_name }}
                </div>
                <i class="fa-solid fa-circle-info bg-icon"></i>
              </div>

              <div class="info-card" [style.border-top-color]="'#3b8bd4'">
                <div class="card-header">
                  <div class="icon-badge" [style.background]="'#3b8bd4'">
                    <i class="fa-solid fa-coins"></i>
                  </div>
                  <div class="card-title">Total Spend</div>
                </div>
                <div class="card-desc" [title]="fmt(detailEntity.amount)">
                  {{ fmt(detailEntity.amount) }}
                </div>
                <i class="fa-solid fa-coins bg-icon"></i>
              </div>

              <div class="info-card" [style.border-top-color]="'#c0473f'">
                <div class="card-header">
                  <div class="icon-badge" [style.background]="'#c0473f'">
                    <i class="fa-regular fa-calendar"></i>
                  </div>
                  <div class="card-title">Active Years</div>
                </div>
                <div class="card-desc">
                  {{ detailEntity.years.length }}
                </div>
                <i class="fa-regular fa-calendar bg-icon"></i>
              </div>
            </div>
          </div>
          <div class="scroll-body">
            <div class="section-block">
              <div class="section-title">
                <span style="margin-left: 10px;">
                  Year-Wise Spend
                </span>
                <span style="display: flex; flex-direction: row; gap: 10px;">
                  <button class="btn-secondary" style="padding: 5px 10px !important;" (click)="shortByAmount()">
                    <div *ngIf="shortAmountBasedOnAcesnding"> L <i class="fa-solid fa-arrow-right"></i> H <span> By
                        Amount </span> </div>
                    <div *ngIf="!shortAmountBasedOnAcesnding"> H <i class="fa-solid fa-arrow-right"></i> L <span> By
                        Amount </span>
                    </div>
                    <span class="filter-badge" *ngIf="selectedFilter==='AMOUNT'">
                      <i class="fa-solid fa-check"></i>
                    </span>
                  </button>
                  <button class="btn-secondary" style="padding: 5px 10px !important;" (click)="shortByYears()">
                    <div *ngIf="shortYearsBasedOnAcesnding"> L <i class="fa-solid fa-arrow-right"></i> H <span> By Year
                      </span> </div>
                    <div *ngIf="!shortYearsBasedOnAcesnding"> H <i class="fa-solid fa-arrow-right"></i> L <span> By Year
                      </span>
                    </div>
                    <span class="filter-badge" *ngIf="selectedFilter==='YEAR'">
                      <i class="fa-solid fa-check"></i>
                    </span>
                  </button>
                </span>
              </div>
              <div class="year-row" *ngFor="let y of detailEntity.years; let i = index" [style.--index]="i">
                <div class="year-header" (click)="getReportData(detailEntity,y)" [ngClass]="{'hover-effect': true}"
                  style="display: flex; flex-direction: row; justify-content: space-between;"
                  [title]="'Click For Redirect To Year ' + y.year + ' Report Of ' + detailEntity.form_name">
                  <div>
                    <span class="year-lbl">{{ y.year }}</span>
                  </div>
                  <div style="display: flex; flex-direction: row; gap: 60px;">
                    <span class="year-amt">{{ fmt(y.amount) }}</span>
                    <span class="year-amt">{{ yearBarWidth(y.amount) }}</span>
                  </div>
                </div>
                <div class="year-track">
                  <div #yearFill class="year-fill" [style.width]="yearBarWidth(y.amount)" [style.background]="'#3b8bd4'"
                    [style.animation-delay]="(i * 0.1) + 's'">
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>